module.exports = __webpack_public_path__ + "media/images/icons/filled/unlock-0112a5fae46f29f17a28cbe4bcbec524.svg";